import { createAsyncThunk } from '@reduxjs/toolkit';
import { Enums, Paths, Value } from '@utils/constants';
import { axios } from '@utils/lib';
import { addLoading, removeLoading } from '../appAction';

/** Face Id API */
export const getFaceIdListAsync = createAsyncThunk(
  'api/getFaceIdListAsync',
  async (request: IFaceIdListParams, { rejectWithValue, dispatch }) => {
    const { query, keys, connection, faceId, hiddenLoading } = request;
    !hiddenLoading && dispatch(addLoading());
    const searchQuery: Record<string, string> = {
      page: query.page ?? Value.TABLE_PAGE_INIT,
      pageSize: query.pageSize ?? Value.TABLE_PAGE_SIZE,
    };

    if (query.camera) searchQuery.camera = query.camera;
    if (query.location) searchQuery.location = query.location;

    const params = new URLSearchParams(searchQuery).toString();
    try {
      const { data } = await axios.request<IListRes<FaceIdRes>>(
        Enums.HTTP_METHOD.GET,
        Paths.FACE_ID + '/' + keys + faceId + connection + '?' + params,
        null,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      !hiddenLoading && dispatch(removeLoading());
    }
  },
);

export const getFaceIdDetailsAsync = createAsyncThunk(
  'api/getFaceIdDetailsAsync',
  async (query: IFaceIdDetailQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IDataRes<FaceIdRes>>(
        Enums.HTTP_METHOD.GET,
        Paths.FACE_ID + '/' + query.dbType + '/' + query.id,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const faceIdUpdateAsync = createAsyncThunk(
  'api/faceIdUpdateAsync',
  async (query: IFaceIdUpdateQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IDataRes<FaceIdRes>>(
        Enums.HTTP_METHOD.PUT,
        Paths.UPDATE_FACE_ID.replace(':dbType', query.dbType).replace(
          ':id',
          String(query.id),
        ),
        query.data,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
